module.exports = __webpack_public_path__ + "static/employsure-4efc72917932f356740c152275ec09f3.png";